export default __webpack_public_path__ + "static/media/cia-house-cropped.6ca48bd1.jpg";